<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { openActivityH5 } from "@/utils/index";
export default {
  data(){
    return {
      routerType:{
        "activity":"报名",
        "question":"问答",
        "examine":"问卷",
        "vote":"投票",
        "raffle":"抽奖",
        "competition":"问答竞赛",                                                                                                                                           
        "conferenceEventDisplay":"展示",
        "customized":"定制"
      }
    }
  },
  watch:{
    "$route.fullPath":{
      handler(val){
        setTimeout(()=>{
          //省宣统计代码
          this.initCnzzTracking(val)
        },800)
      },
      deep:true,
    },     
  },
  methods: {
    //给活动进行埋点
    initCnzzTracking(val) {
      const flag1 =['competition',"conferenceEventDisplay"].includes(this.$route.name)? this.$route.name:(this.$route.name && this.$route.params.id)
      const flag2 = document.title && document.title !=='登录'
      const flag3 = process.env.NODE_ENV === 'production'
      const flag = !!(flag1&&flag2&&flag3) 
      if(flag){
        //友盟
        var _czc = window._czc || [];
        const params1 ="运营"+ (this.routerType[this.$route.name]??'定制')+(this.$route.params.id??"")
        const params2= document.title
        const params3 = "运营H5访问"
        _czc.push(["_setAccount", "1279551605"]); // 使用您的siteid替换这里的数字
        _czc.push(["_trackEvent",params1,params2, params3]);
        //省宣统计
        let path = "https://sp.timedg.com/H5" + val
        const id = this.$md5(path)
        openActivityH5(id,params1+"-"+params2+":"+path)
        //报社内部统计代码
        if (window.timestatloader && window.timestatloader.stat) {
          window.timestatloader.stat.collectEvent("运营系统H5访问pv", {
            idx: params1+":"+params2,
          });
        }else{
          console.log("window.timestatloader加载错误",window.timestatloader)
        }
      }
    }
  }
}
</script>

